/**
 * @file "异步分页选择组件"
 */

import { Input, List, Search } from "@/components/Base"
import { Icon, Popup } from "vant"
import { computed, defineComponent, ref } from "vue"
import styles from "./index.module.less"
import { debounce } from "lodash"

const fieldKey = { labelKey: "name", valueKey: "id" }

export const AsyncSelect = defineComponent({
  name: "SelectSchool",
  props: {
    modelValue: { type: Object },
    fieldKey: { default: fieldKey, type: Object },
    searchConfig: { type: Object },
    getList: { type: Function, required: true },
    onBeforeOpen: { type: Function, default: () => true },
    listProps: { type: Object }
  },
  emits: ["update:modelValue", "beforeOpen"],
  setup(props, { emit, slots }) {
    const modelValue = computed({
      get() {
        const { labelKey } = props.fieldKey
        return props.modelValue?.[labelKey] || ""
      },
      set(value) {
        visible.value = false
        emit("update:modelValue", value)
      }
    })

    const visible = ref(false)

    // 渲染触发器
    const onTrigger = () => {
      if (props.onBeforeOpen() !== false) {
        visible.value = true
        listRef.value?.refresh()
      }
    }
    const DefaultRenderer = () => {
      if (slots.default) {
        return slots.default()
      } else {
        return (
          <Input placeholder="请选择" modelValue={modelValue.value} readonly />
        )
      }
    }
    const TriggerRenderer = () => {
      return (
        <div class={styles.showValue} onClick={onTrigger}>
          {DefaultRenderer()}
          <Icon name="arrow" class={styles.iconRight}></Icon>
        </div>
      )
    }

    // 渲染列表
    const listRef = ref()
    const listSlots = {
      default: (v) => {
        const { labelKey, valueKey } = props.fieldKey
        const toSelect = () => {
          modelValue.value = { id: v[valueKey], name: v[labelKey] }
        }
        return (
          <div class={styles.schoolItem} onClick={toSelect}>
            <div class="flex--a-c">
              <div class={styles.name}>{v[labelKey]}</div>
            </div>
            <Icon name="arrow" class={styles.iconRight}></Icon>
          </div>
        )
      }
    }
    const getList = (params) => {
      return props
        .getList({
          ...params,
          search: search.value ?? ""
        })
        .then((res) => {
          return res.data
        })
    }
    const listProps = computed(() => {
      return {
        refresh: true,
        useSearch: false,
        paging: true,
        class: styles.scroll,
        ...props.listProps,
        getList
      }
    })
    const ListRenderer = () => {
      return <List ref={listRef} vSlots={listSlots} {...listProps.value} />
    }
    const search = ref("")
    const newSearch = ref("")
    const refresh = debounce(() => {
      if (newSearch.value !== search.value) {
        search.value = newSearch.value
        listRef.value.refresh()
      }
    }, 1000)

    // 渲染选择弹窗
    const onSearch = (value) => {
      newSearch.value = value.trim()
      refresh()
    }
    const cancel = () => {
      visible.value = false
    }
    const PopupRender = () => {
      return (
        <Popup
          v-model:show={visible.value}
          position="right"
          duration={0.2}
          teleport="body"
        >
          <div class={styles.popupBox}>
            <div class={styles.header}>
              <Search
                class={styles.search}
                onSearch={onSearch}
                searchConfig={props.searchConfig}
              />
            </div>
            {ListRenderer()}
            <div className={styles.base}>
              <div class={styles.baseLightButton} onClick={cancel}>
                取消
              </div>
            </div>
          </div>
        </Popup>
      )
    }

    return () => (
      <>
        {TriggerRenderer()}
        {PopupRender()}
      </>
    )
  }
})
